import styled from 'styled-components';
import { durations } from '@cbhq/cds-common/motion/tokens';
import { palette, spacing } from '@cbhq/cds-web/tokens';
import '../../ui/Div/index.js';
import { NAVBAR_NAV_HEIGHT, NAVBAR_BANNER_HEIGHT } from './constants.js';
import { TrapdoorDescriptionColumn } from './TrapdoorDescriptionColumn.js';
import { TrapdoorProductListColumn } from './TrapdoorProductListColumn.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
function Trapdoor({
  isActive,
  links,
  productLink,
  hasBanner = false
}) {
  return /*#__PURE__*/jsx(Wrapper, {
    isActive: isActive,
    hasBanner: hasBanner,
    children: /*#__PURE__*/jsxs(Div, {
      maxWidth: 1065,
      justifyContent: "center",
      children: [/*#__PURE__*/jsx(ColumnWrapper, {
        children: links.map(({
          url,
          label,
          description,
          icon,
          linkTarget
        }, index) => {
          return /*#__PURE__*/jsx(TrapdoorProductListColumn, {
            header: label,
            subhead: description,
            iconUrl: icon,
            url: url,
            target: linkTarget
          }, `${index}-${label}`);
        })
      }), productLink && /*#__PURE__*/jsx(TrapdoorDescriptionColumn, {
        header: productLink.label,
        subhead: productLink.description,
        labelCta: productLink.urlLabel,
        url: productLink.url
      })]
    })
  });
}
const COLUMN_GAP = 34;
const ROW_GAP = 20;
const Wrapper = styled.section.withConfig({
  shouldForwardProp: p => !['isActive', 'hasBanner'].includes(p)
})`
  background: ${palette.background};
  transition:
    all ${durations.fast3}ms linear,
    box-shadow 0ms linear;
  text-align: left;
  display: none;
  position: absolute;
  top: ${({
  hasBanner
}) => hasBanner ? NAVBAR_NAV_HEIGHT + NAVBAR_BANNER_HEIGHT + 1 : NAVBAR_NAV_HEIGHT + 1}px;

  box-sizing: border-box;
  cursor: initial;

  left: 0;
  width: 100%;
  ${({
  isActive
}) => isActive ? `
          display: flex;
          justify-content: center;
          padding: ${spacing[6]};
          transition: display ${durations.fast3}ms linear;
          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
        ` : ''}
`;
const ColumnWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, max-content);
  column-gap: ${COLUMN_GAP}px;
  row-gap: ${ROW_GAP}px;
  grid-auto-flow: row;
  margin-right: 60px;
`;
export { Trapdoor };
//# sourceMappingURL=Trapdoor.js.map
